var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#D4D6D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.34 10.322a1 1 0 1 0-1.364-1.463l-4.926 4.728-4.728-4.927a1 1 0 1 0-1.463 1.364l4.728 4.926-4.927 4.727a1 1 0 1 0 1.364 1.463l4.926-4.727 4.727 4.926a1 1 0 1 0 1.463-1.363l-4.727-4.926z"
  })));
};
export default SvgCancel;